import { Button, Icons, LiveTicker, WaxSeal } from "@jod/ui";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useT } from "../features/i18n/index.ts";
import { LocaleSwitcher } from "../features/i18n/locale-switcher.tsx";
import { activityLines, mockVenue } from "../mocks/data.ts";

export const Route = createFileRoute("/welcome")({
  component: WelcomeScreen,
});

function WelcomeScreen() {
  const t = useT();
  const navigate = useNavigate();

  return (
    <div className="relative mx-auto flex min-h-dvh w-full max-w-md flex-col overflow-hidden">
      <div className="jod-ambient" aria-hidden="true" />
      <div className="jod-grain" aria-hidden="true" />

      {/* unobtrusive Thai/EN switch (I18N-009) */}
      <div className="absolute top-[calc(0.75rem+env(safe-area-inset-top))] right-4 z-20">
        <LocaleSwitcher />
      </div>

      <div className="jod-stagger relative z-10 flex flex-1 flex-col items-center justify-center gap-6 px-7 text-center">
        <WaxSeal size={108} />
        <div className="space-y-2">
          <h1 className="h-display text-[2.6rem] leading-tight" lang="th">
            {t("brand.appName")}
          </h1>
          <p className="jod-wordmark mx-auto">Just One Drink</p>
          <p className="mx-auto mt-3 max-w-[16rem] text-cream-2 leading-relaxed">
            {t("welcome.tonightAt", { venue: mockVenue.name, session: mockVenue.session })}
          </p>
        </div>
        <div className="glass flex w-full max-w-[18rem] items-center justify-center rounded-lg px-4 py-2.5">
          <LiveTicker items={activityLines} />
        </div>
      </div>

      <div className="jod-stagger relative z-10 space-y-3 px-7 pb-[calc(2rem+env(safe-area-inset-bottom))]">
        <Button size="lg" className="w-full" onClick={() => navigate({ to: "/age-gate" })}>
          <Icons.IconCheers size={20} /> {t("welcome.start")}
        </Button>
        <Button
          size="lg"
          variant="ghost"
          className="w-full"
          onClick={() => navigate({ to: "/menu" })}
        >
          {t("welcome.orderOnly")}
        </Button>
      </div>
    </div>
  );
}
